import { VisibilityType } from "../types/types";

export const visibilityTitleByVisibility = new Map<VisibilityType, string>([
  ["visible_only_to_me", "Visible only to me"],
  ["visible_to_everyone", "Visible to everyone"],
]);
